import { useContext } from 'react';
import { BuyItAgainItemContext } from '../components/contexts/BuyItAgainItemContext';
import { useLineItemData } from '../components/contexts/LineItemDataContext';

/**
 * Custom hook to determine the correct quantity for an item.
 *
 * If the item is rendered within a BuyItAgainItemContext (BIA pages),
 * it respects the quantity selected in the dropdown.
 * Otherwise, it defaults to the existing quantity on the item.
 *
 * This logic is shared between ItemBuyNowButton and ItemAddToCartButton.
 */
export const useReorderQuantity = () => {
  const item = useLineItemData();
  const BIAContext = useContext(BuyItAgainItemContext);

  const { selectedPricedQuantity } = BIAContext || {};
  const quantity = selectedPricedQuantity?.quantity ?? item.quantity;

  return { quantity, selectedPricedQuantity };
};
